<template>
  <Takeover active class="takeover-container">
    <CheckoutHeader />
    <CheckoutContent />
    <UniversalModal />
  </Takeover>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import Takeover from '@/components/shared/Takeover.vue'
import CheckoutHeader from '@/components/shared/header/CheckoutHeader.vue'
import CheckoutContent from '@/components/shared/CheckoutContent.vue'
import UniversalModal from '@/components/shared/UniversalModal.vue'
import { useHotKeyStore } from '@/store/HotKeyStore'
import { useHead } from '@unhead/vue'
import { useProductStore } from '@/store/ProductStore'
import { useAmplitude } from '@outputinc/o-analytics'
import { usePlanStore } from '@/store/PlanStore'

const { track, Events } = useAmplitude()
const { keyUpEventListener } = useHotKeyStore()
const productStore = useProductStore()
const { productName } = storeToRefs(productStore)
const planStore = usePlanStore()
const { selectedPlanCode } = storeToRefs(planStore)

useHead({
  title: () => `Get ${productName.value} - Output`
})

onMounted(() => {
  eventListeners()
  track(Events.CHECKOUT_SUBSCRIPTION_UPGRADE_VIEW, {
    selectedPlanCode: selectedPlanCode.value
  })
})

const eventListeners = () => {
  window.addEventListener('keyup', event => keyUpEventListener(event), false)
}
</script>

<style scoped lang="scss">
.takeover-container {
  overflow: scroll;
  scrollbar-width: none;
}
</style>
